<!-- 由 suu 创建于 2022-06-23 Thursday -->
<template>
  <div class="ques-checkbox">
    <div class="tips">（多选）</div>
    <div class="title">{{ curQues.field_title }}</div>
    <div class="radio-list" :class="[type]">
      <div
        :class="{ 'radio-item': true, 'radio-item-active': valueList[index] }"
        @click="bindchange(item)"
        v-for="(item, index) in curQues.field_unit"
        :key="index"
      >
        {{ item.value }}
      </div>
    </div>
    <div v-if="showTextArea">
      <textarea
        class="textarea"
        @input="bindinput"
        v-model="extra"
        placeholder="请输入其他信息"
      ></textarea>
    </div>
    <div class="desc">
      <text class="text">{{ curQues.sub_text }}</text>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-checkbox',

  components: {},

  props: {
    max: {
      type: Number,
      value: 0
    },
    curQues: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data() {
    return {
      flexTypeList: ['column', 'row', 'row3'],
      type: 'column', //排序类型
      value: [], //选中的数据
      score: 0, // 分数，
      valueList: [],
      selectNum: 0, //最大选中数量 为0表示不限制数量
      showTextArea: false, //是否显示输入其他信息的文本框
      extra: '', //额外的输入信息
      contraryList: [] //选项互斥的选项key
    }
  },

  computed: {},

  watch: {
    curQues(val) {
      this.updateAllData(val)
      this.computeFlexType(val)
    },
    //监听多选框数据的变化
    value(val) {
      val = val || []
      let valueList = []
      let showTextArea = false
      this.curQues.field_unit.map((item) => {
        if (val.indexOf(item.key) >= 0) {
          valueList.push(true)
        } else {
          valueList.push(false)
        }
        if (item.is_extra && val.indexOf(item.key) >= 0) {
          showTextArea = true
        }
      })
      this.valueList = valueList
      this.showTextArea = showTextArea
    }
  },

  created() {
    this.updateAllData(this.curQues)
    this.computeFlexType(this.curQues)
  },

  mounted() {},

  destroyed() {},

  methods: {
    //获取相反选项
    getContraryList(data) {
      let arr = []
      data.field_unit.map((item) => {
        if (item.is_spe) {
          arr.push(item.key)
        }
      })
      this.contraryList = arr
      console.log('====================================')
      console.log('arr', arr)
      console.log('====================================')
    },
    //更新组件的所有数据
    updateAllData(data) {
      console.log('====================================')
      console.log('当前', data)
      console.log('====================================')
      this.getContraryList(data)
      const value = data['value'] || []
      this.value = data['value'] || []
      this.score = data['data_num'] || 0
      this.selectNum = value.length
      this.extra = data.extra || ''
    },
    //更新多选框选中的状态
    updateStatus() {
      let arr = []
      this.field_unit.map((item) => {
        if (this.active.indexOf(item.key) >= 0) {
          arr.push(true)
        } else {
          arr.push(false)
        }
      })
      this.activeList = arr
    },
    computeFlexType(data) {
      let len = data.field_unit.length
      // console.log('computeFlexType', data, len)
      let maxTextLength = 0
      data.field_unit.map((item) => {
        maxTextLength =
          item.value.length > maxTextLength ? item.value.length : maxTextLength
      })
      let type = 'column'
      if (len > 5 && len <= 12) {
        type = 'row2'
      } else if (len > 12 && maxTextLength <= 5) {
        type = 'row3'
      } else if (len > 12 && maxTextLength > 5) {
        type = 'row2'
      }
      this.type = type
    },
    bindinput(e) {
      this.$emit(
        'change',
        {
          value: this.value,
          score: this.score,
          extra: this.extra
        },
        {}
      )
    },
    bindchange(item) {
      let key = item.key
      let is_spe = item.is_spe
      let is_extra = item.is_extra
      let score = item.score || 0
      if (is_spe) {
        //如果是互斥则只选中这一个并隐藏输入框
        this.value = [key]
        this.score += score
        this.showTextArea = false
        this.$emit(
          'change',
          {
            value: this.value,
            score: this.score,
            extra: this.extra
          },
          {}
        )
        return
      } else {
        //点击的不是互斥选项则在选中的选项列表中删除
        this.value = this.value.filter((item, index) => {
          return this.contraryList.indexOf(item) < 0
        })
      }
      let arrIndex = this.value.indexOf(key) //key在选择选项中是否存在
      if (arrIndex >= 0) {
        //如果存在则删除
        this.value.splice(arrIndex, 1)
        this.score -= score
        if (is_extra) {
          this.setData({
            extra: '',
            showTextArea: false
          })
        }
      } else {
        //不存在则判断是否有最大限制数量，有则判断是否超出，不超过则添加
        if (this.max && this.value.length >= this.max) {
          return
        } else {
          this.value.push(key)
          this.score += score
          if (is_extra) {
            this.showTextArea = true
          }
        }
      }
      this.$emit(
        'change',
        {
          value: this.value,
          score: this.score,
          extra: this.extra
        },
        {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-checkbox {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -10px;
  .title {
    width: vw(530);
    text-align: center;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #202539;
    line-height: 32px;
    word-break: break-all;
  }

  .tips {
    text-align: center;
    font-size: vw(30);
    // margin-top: vw(23);
    font-size: 12px;
    font-weight: 600;
    color: #373d52;
    line-height: 21px;
  }

  .radio-list {
    margin-top: 28px;
  }

  .row2 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;
  }

  .row3 {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    justify-content: center;
  }

  .row2 .radio-item {
    max-width: vw(280);
    width: vw(280);
    margin-right: vw(20);
  }

  .row3 .radio-item {
    box-sizing: border-box;
    // min-height: vw(0);
    width: vw(180);
    margin-right: vw(20);
  }

  .row2 .radio-item:nth-child(2n) {
    margin-right: vw(0);
  }

  .row3 .radio-item:nth-child(3n) {
    margin-right: vw(0);
  }

  .column {
    display: inline-block;
  }

  .column .radio-item {
    min-width: vw(280);
  }

  .radio-item {
    text-align: center;
    // min-height: 48px;
    box-sizing: border-box;
    // line-height: vw(32);
    background-color: #fff;
    border-radius: vw(1000);
    font-size: vw(30);
    padding: vw(15);
    line-height: 23px;
    color: #373d52;
    margin-bottom: vw(32);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .radio-item-active {
    /* background-image: linear-gradient(90deg, 
		#3663e6 0%, 
    #5e89f6 100%); */
    background: #c9bbff;
    color: #fff;
    font-weight: 600;
  }

  .desc {
    width: vw(484);
    margin: 0 auto;
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
  }

  .desc .text {
    display: inline-block;
    text-align: left;
  }

  .textarea {
    text-align: left;
    padding: vw(10) vw(44);
    width: 100%;
    height: vw(80);
    line-height: vw(36);
    background-color: #fff;
    border-radius: vw(44);
    border: solid vw(4) #4b77ee;
    box-sizing: border-box;
    margin-bottom: vw(40);
  }
}
</style>
